import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FaqContainerService } from './faq-container.service';
import { FaqData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-faq-container',
  template: `
    <fcp-faq [data]="data | async"></fcp-faq>
  `
})
export class FaqContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<FaqData[]>;
  constructor(private faqContainerService: FaqContainerService) {}

  ngOnInit() {
    this.data = this.faqContainerService.getFaq(this.id);
  }
}
